import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDownIcon, SofaIcon, LeafIcon, ShieldCheckIcon, BoxIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    text: 'Energiekosten reduzieren',
    icon: TrendingDownIcon
  }, {
    text: 'Wohnkomfort verbessern',
    icon: SofaIcon
  }, {
    text: 'Fördermittel optimal nutzen',
    icon: BoxIcon
  }, {
    text: 'Immobilienwert steigern',
    icon: BoxIcon
  }, {
    text: 'Ressourcen schonen',
    icon: LeafIcon
  }, {
    text: 'Zukunftssicher modernisieren',
    icon: ShieldCheckIcon
  }];
  return <section className="py-24 bg-accent text-secondary overflow-hidden" data-id="element-33">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-34">
        <div className="grid lg:grid-cols-12 gap-16 items-center" data-id="element-35">
          <div className="lg:col-span-5" data-id="element-36">
            <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-37">
              Warum eine Energieberatung?
            </h2>
            <p className="text-secondary/70 font-light text-lg leading-relaxed mb-8" data-id="element-38">
              Eine fundierte Beratung ist der erste Schritt zu einem
              zukunftsfähigen Gebäude. Sie schafft Klarheit über sinnvolle
              Maßnahmen, verhindert Fehlinvestitionen und sichert maximale
              Förderungen.
            </p>
          </div>

          <div className="lg:col-span-7" data-id="element-39">
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-40">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-center p-4 rounded-xl bg-white/5 border border-white/10" data-id="element-41">
                  <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center mr-4 shrink-0 text-primary-light" data-id="element-42">
                    {/* Fallback to generic lucide icons if specific ones aren't available */}
                    <benefit.icon size={20} strokeWidth={1.5} data-id="element-43" />
                  </div>
                  <span className="font-medium tracking-wide text-sm md:text-base" data-id="element-44">
                    {benefit.text}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}